<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="signContractWin" :model="formData" class="full-width-input" style="width: 100%;" :rules="rules"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="服务对象" prop="SpecialistHis.serviceObjectName">
            <el-input class="input-item" v-model="formData.SpecialistHis.serviceObjectName"
              :clearable="true" placeholder="服务对象"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所在地区" prop="SpecialistHis.serviceAreaId">
            <el-cascader class="input-item" v-model="signContractWin.serviceAreaId.value" :options="signContractWin.serviceAreaId.impl.dropdownList" filterable
              :clearable="true" :show-all-levels="true" placeholder="所在地区"
              :props="{value: 'id', label: 'name', checkStrictly: true}"
              @visible-change="signContractWin.serviceAreaId.impl.onVisibleChange"
              @change="onServiceAreaIdValueChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人" prop="SpecialistHis.contactsUser">
            <el-input class="input-item" v-model="formData.SpecialistHis.contactsUser"
              :clearable="true" placeholder="请输入服务对象联系人"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="SpecialistHis.contactsUserTel">
            <el-input class="input-item" v-model="formData.SpecialistHis.contactsUserTel"
              :clearable="true" placeholder="请输入服务对象联系人电话"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="主营业务" prop="SpecialistHis.mainBusiness">
            <el-input class="input-item" v-model="formData.SpecialistHis.mainBusiness"
              type="textarea"
              :autosize="{minRows: 4, maxRows: 8}"
              :clearable="true" placeholder="请填写服务对象主营业务"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="服务期" prop="SpecialistHis.signYear">
            <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYear" :clearable="true"
              format="yyyy"
              value-format="yyyy-MM-dd"
              type="year" align="left"
              placeholder="服务期"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="服务对象需求" prop="SpecialistHis.serviceUserRequirement">
            <el-input class="input-item" v-model="formData.SpecialistHis.serviceUserRequirement"
              :clearable="true" placeholder="（受援单位提出需要解决的技术问题等）"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="服务方式" prop="SpecialistHis.serviceType">
            <el-input class="input-item" v-model="formData.SpecialistHis.serviceType"
                      type="textarea"
                      :autosize="{minRows: 4, maxRows: 8}"
              :clearable="true" placeholder="（根据受援单位需求，科技人员可提供的服务方式：专业技术服务，与农民结成利益共同体、创办领办农民合作社、企业等，推进农村科技创新创业，培养本土科技人才等。）"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="服务内容" prop="SpecialistHis.serviceContent">
            <el-input class="input-item" v-model="formData.SpecialistHis.serviceContent"
                      type="textarea"
                      :autosize="{minRows: 4, maxRows: 8}"
              :clearable="true" placeholder="（根据受援单位需求开展的服务内容、预计成效等）"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="三方协议书" prop="SpecialistHis.contractFiles">
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/app/specialistHis/upload')"
              :data="{fieldName: 'contractFiles', asImage: false}"
              :on-success="onContractFilesUploadSuccess"
              :on-remove="onContractFilesRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="signContractWin.contractFiles.impl.maxCount"
              :file-list="signContractWin.contractFiles.impl.fileList"
              :show-file-list="true">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="其他附件" prop="SpecialistHis.attachedFiles">
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/app/specialistHis/upload')"
              :data="{fieldName: 'attachedFiles', asImage: false}"
              :on-success="onAttachedFilesUploadSuccess"
              :on-remove="onAttachedFilesRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="signContractWin.attachedFiles.impl.maxCount"
              :file-list="signContractWin.attachedFiles.impl.fileList"
              :show-file-list="true">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('signContractWin:signContractWin:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              关闭
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SpecialistHisController, DictionaryController } from '@/api';

export default {
  name: 'signContractWin',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    },
    specialistId: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        SpecialistHis: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistId: undefined,
          specialistName: undefined,
          serviceObjectName: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          mainBusiness: undefined,
          signYear: undefined,
          serviceUserRequirement: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          contractFiles: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'SpecialistHis.serviceObjectName': [
          {required: true, message: '请输入服务对象', trigger: 'change'}
        ],
        'SpecialistHis.serviceAreaId': [
          {required: true, message: '请选择所在地区', trigger: 'change'}
        ],
        'SpecialistHis.contactsUser': [
          {required: true, message: '请输入服务对象联系人', trigger: 'change'}
        ],
        'SpecialistHis.contactsUserTel': [
          {required: true, message: '请输入服务对象联系人电话', trigger: 'change'}
        ],

        'SpecialistHis.mainBusiness': [
          {required: true, message: '请填写服务对象主营业务', trigger: 'change'}
        ],

        'SpecialistHis.identityCardNo': [
          {required: true, message: '请输入法人识别号', trigger: 'change'}
        ]
      },
      signContractWin: {
        formFilter: {
        },
        formFilterCopy: {
        },
        serviceAreaId: {
          impl: new DropdownWidget(this.loadServiceAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        contractFiles: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(1)
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 所在地区下拉数据获取函数
     */
    loadServiceAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所在地区选中值改变
     */
    onServiceAreaIdValueChange (value) {
      this.formData.SpecialistHis.serviceAreaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 更新签约委派弹窗
     */
    refreshSignContractWin (reloadData = false) {
      this.loadSpecialistHisData().then(res => {
        if (!this.signContractWin.isInit) {
          // 初始化下拉数据
          this.signContractWin.serviceAreaId.impl.onVisibleChange(true).then(res => {
            this.signContractWin.serviceAreaId.value = findTreeNodePath(res, this.formData.SpecialistHis.serviceAreaId, 'id');
          }).catch(e => {});
        }
        this.signContractWin.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.signContractWin.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            serviceAreaIdDictMap: findTreeNode(this.signContractWin.serviceAreaId.impl.dropdownList, this.formData.SpecialistHis.serviceAreaId, 'id'),
            ...this.formData.SpecialistHis
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          specialistHisDto: {
            attachedFiles: this.formData.SpecialistHis.attachedFiles,
            contractFiles: this.formData.SpecialistHis.contractFiles,
            id: this.formData.SpecialistHis.id,
            orgCode: this.formData.SpecialistHis.orgCode,
            specialistId: this.formData.SpecialistHis.specialistId,
            specialistName: this.formData.SpecialistHis.specialistName,
            serviceObjectName: this.formData.SpecialistHis.serviceObjectName,
            serviceAreaId: this.formData.SpecialistHis.serviceAreaId,
            serviceAreaName: this.formData.SpecialistHis.serviceAreaName,
            contactsUser: this.formData.SpecialistHis.contactsUser,
            contactsUserTel: this.formData.SpecialistHis.contactsUserTel,
            mainBusiness: this.formData.SpecialistHis.mainBusiness,
            signYear: this.formData.SpecialistHis.signYear,
            serviceUserRequirement: this.formData.SpecialistHis.serviceUserRequirement,
            serviceType: this.formData.SpecialistHis.serviceType,
            serviceContent: this.formData.SpecialistHis.serviceContent
          }
        };

        if (this.id === undefined) {
          params.specialistHisDto.specialistId = this.specialistId;
          SpecialistHisController.add(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        } else {
          SpecialistHisController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }
      });
    },
    /**
     * 获取专家对接历史详细信息
     */
    loadSpecialistHisData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.SpecialistHis.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          SpecialistHisController.view(this, params).then(res => {
            this.formData.SpecialistHis = {...res.data, isDatasourceInit: true};
            if (this.formData.SpecialistHis.serviceAreaIdDictMap && this.signContractWin.serviceAreaId.impl.dirty) {
              this.signContractWin.serviceAreaId.impl.dropdownList = [this.formData.SpecialistHis.serviceAreaIdDictMap];
            }
            if (this.formData.SpecialistHis.serviceAreaId) this.signContractWin.serviceAreaId.value = [this.formData.SpecialistHis.serviceAreaId];
            let contractFilesDownloadParams = {
              id: this.formData.SpecialistHis.id,
              fieldName: 'contractFiles',
              asImage: false
            }
            this.signContractWin.contractFiles.impl.fileList = this.parseUploadData(this.formData.SpecialistHis.contractFiles, contractFilesDownloadParams);
            let attachedFilesDownloadParams = {
              id: this.formData.SpecialistHis.id,
              fieldName: 'attachedFiles',
              asImage: false
            }
            this.signContractWin.attachedFiles.impl.fileList = this.parseUploadData(this.formData.SpecialistHis.attachedFiles, attachedFilesDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.SpecialistHis.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 三方协议书上传成功
     */
    onContractFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.signContractWin.contractFiles.impl.onFileChange(file, fileList);
        this.formData.SpecialistHis.contractFiles = this.fileListToJson(this.signContractWin.contractFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除三方协议书
     */
    onContractFilesRemoveFile (file, fileList) {
      this.signContractWin.contractFiles.impl.onFileChange(file, fileList);
      this.formData.SpecialistHis.contractFiles = this.fileListToJson(this.signContractWin.contractFiles.impl.fileList);
    },
    /**
     * 其他附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.signContractWin.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.SpecialistHis.attachedFiles = this.fileListToJson(this.signContractWin.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除其他附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.signContractWin.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.SpecialistHis.attachedFiles = this.fileListToJson(this.signContractWin.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SpecialistHis: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistId: undefined,
          specialistName: undefined,
          serviceObjectName: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          mainBusiness: undefined,
          signYear: undefined,
          serviceUserRequirement: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          contractFiles: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshSignContractWin();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.SpecialistHis = {
        ...this.rowData
      }
      if (this.formData.SpecialistHis.serviceAreaIdDictMap && this.signContractWin.serviceAreaId.impl.dirty) {
        this.signContractWin.serviceAreaId.impl.dropdownList = [this.formData.SpecialistHis.serviceAreaIdDictMap];
      }
      if (this.formData.SpecialistHis.serviceAreaId) this.signContractWin.serviceAreaId.value = [this.formData.SpecialistHis.serviceAreaId];
      let contractFilesDownloadParams = {
        id: this.formData.SpecialistHis.id,
        fieldName: 'contractFiles',
        asImage: false
      }
      this.signContractWin.contractFiles.impl.fileList = this.parseUploadData(this.formData.SpecialistHis.contractFiles, contractFilesDownloadParams);
      let attachedFilesDownloadParams = {
        id: this.formData.SpecialistHis.id,
        fieldName: 'attachedFiles',
        asImage: false
      }
      this.signContractWin.attachedFiles.impl.fileList = this.parseUploadData(this.formData.SpecialistHis.attachedFiles, attachedFilesDownloadParams);
    }
  },
  watch: {
  }
}
</script>
